var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('zoom-info-form',{attrs:{"title":"zoom_meeting.add_new_zoom_meeting"},on:{"submitForm":_vm.submitForm}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }